// extracted by mini-css-extract-plugin
export default {"filesView":"styles_filesView__BW0E-","files":"styles_files__zKkj1","select":"styles_select__Wkbku","ui-spin":"styles_ui-spin__YEnvb"};